export function removeUnsupportedBrowserBanner() {
    try {
        const elements = document.querySelectorAll('[data-atid="unsupported-browser-banner"]');
        for (const elem of elements) {
            elem.remove();
        }
    } catch (e) {
        console.error(e);
    }
}
